var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarparking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.99297L15.4 5.04297H6.50832L5.40833 9.99297",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.04297V9.6263",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85828 15.6755H2.19995V12.8339C2.19995 11.2755 3.39162 9.99219 4.85828 9.99219H17.05C18.5166 9.99219 19.7083 11.2755 19.7083 12.8339V15.6755H17.2333",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 15.6758H7.8833",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32495 17.0508C7.08434 17.0508 7.69995 16.4352 7.69995 15.6758C7.69995 14.9164 7.08434 14.3008 6.32495 14.3008C5.56556 14.3008 4.94995 14.9164 4.94995 15.6758C4.94995 16.4352 5.56556 17.0508 6.32495 17.0508Z",
    stroke: "#8B8C9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.675 17.0508C16.4344 17.0508 17.05 16.4352 17.05 15.6758C17.05 14.9164 16.4344 14.3008 15.675 14.3008C14.9157 14.3008 14.3 14.9164 14.3 15.6758C14.3 16.4352 14.9157 17.0508 15.675 17.0508Z",
    stroke: "#8B8C9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarparking);
export default __webpack_public_path__ + "static/media/carparking.3c485544.svg";
export { ForwardRef as ReactComponent };